import { render, staticRenderFns } from "./BarcodeScannerModal.vue?vue&type=template&id=635f850e&scoped=true&"
import script from "./BarcodeScannerModal.vue?vue&type=script&lang=js&"
export * from "./BarcodeScannerModal.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeScannerModal.vue?vue&type=style&index=0&id=635f850e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f850e",
  null
  
)

export default component.exports